// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
   width: 100%
}

.mat-dialog-content {
   overflow: hidden;
}

.error {
   font-size: 13px;
   padding: 0 50px 20px;
   text-align: center;
   color: red;
}

mat-dialog-actions{
   margin-top: 12px;
   padding-bottom: 15px;
}

.column {
   padding: 5px 15px;
   max-width: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/create-site/create-site.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,oBAAoB;GACpB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,gBAAgB;GAChB,oBAAoB;AACvB;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB","sourcesContent":[".mat-form-field {\n   width: 100%\n}\n\n.mat-dialog-content {\n   overflow: hidden;\n}\n\n.error {\n   font-size: 13px;\n   padding: 0 50px 20px;\n   text-align: center;\n   color: red;\n}\n\nmat-dialog-actions{\n   margin-top: 12px;\n   padding-bottom: 15px;\n}\n\n.column {\n   padding: 5px 15px;\n   max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
